import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@mui
import { Box } from '@mui/material';
//components
import CostSummary from '../../../components/chancemng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/chancemng/costcalc/CostCalcLockList';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';

const CostCalcLockContainer = () => {
  const dispatch = useDispatch();
  const { chance, costs } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance.chance,
    costs: chanceModule.chanceCosts.costs,
  }));

  useEffect(() => {
    if (chance) {
      dispatch(listChanceCosts(chance.prjUuid));
    }
  }, [chance, dispatch]);

  // [추가] 매입처별 정렬 로직: 소계 행이 정확한 위치에 삽입되도록 함
  const sortedCosts = useMemo(() => {
    if (!costs || costs.length === 0) return [];
    
    return [...costs].sort((a, b) => {
      const nameA = a.sellPartnerNm || '';
      const nameB = b.sellPartnerNm || '';
      // 매입처명 가나다순 정렬
      return nameA.localeCompare(nameB);
    });
  }, [costs]);

  return (
    <Box>
      {/* 
      <Box sx={{ py: 1 }}>
        <CostSummary chance={chance} costsVat={sortedCosts} />
      </Box> 
      */}
      <Box sx={{ py: 1 }}>
        {/* [수정] 정렬된 데이터인 sortedCosts를 전달 */}
        {sortedCosts.length > 0 && <CostCalcLockList costs={sortedCosts} />}
      </Box>
    </Box>
  );
};

export default CostCalcLockContainer;
